<template>
    <div class="application-profile">
        <v-row v-if="application.icon"
               justify="space-around">
            <v-col cols="auto" justify="center">
                <v-avatar size="185"
                          :class="iconClass(application.icon || '')">
                    <img
                        :src="application.icon"
                        :alt="application.name"
                    >
                </v-avatar>
            </v-col>
        </v-row>
        <v-row class="display-1" justify="center">
            {{ application.name }}
        </v-row>
        <v-row class="body-2 font-weight-light text-center px-12" justify="center">
            {{ application.description }}
        </v-row>
    </div>
</template>

<script>
    import ApplicationModel from "../models/application";

    export default {
        name: "ApplicationProfile",
        props: {
            application: ApplicationModel
        },
        methods: {
            iconClass(icon) {
                return icon.toLowerCase().indexOf('.flat.') === -1
                    ? ''
                    : 'flat-icon';
            }
        }
    }
</script>

<style scoped>
    .flat-icon {
        border-radius: 3px;
    }
</style>
